import { Modal, TextInput } from "@risalabs_frontend_org/oasis-ui-kit";
import { useState } from "react";
import { ModalId } from "../../../enums/modalId";
import {
  DOCUMENT_NAME_LABEL,
  JUST_SAVE_LABEL,
  SAVE_AND_UPLOAD_LABEL,
  SAVING_LABEL,
  UPLOAD_TO_DOCUMENTS_TITLE,
} from "../utils/constants";

interface SaveReviewModalProps {
  /** Pre-filled document name (editable before either action). */
  defaultDocumentName: string;
  /** True while a save is in flight; both actions are disabled. */
  isSaving: boolean;
  /** Saves the review; `upload` adds the letter to the J-code's documents too. */
  onSubmit: (documentName: string, upload: boolean) => void;
  onClose: () => void;
}

/**
 * "Upload to Documents" dialog: confirm the document name, then "No, Just Save" (record the review
 * only) or "Save and Upload" (also add the letter to the Documents tab).
 */
const SaveReviewModal = ({
  defaultDocumentName,
  isSaving,
  onSubmit,
  onClose,
}: SaveReviewModalProps) => {
  const [documentName, setDocumentName] = useState(defaultDocumentName);
  const name = documentName.trim();

  return (
    <Modal
      dialogId={ModalId.FAX_LETTER_SAVE_MODAL}
      title={UPLOAD_TO_DOCUMENTS_TITLE}
      cancelText={isSaving ? SAVING_LABEL : JUST_SAVE_LABEL}
      saveButtonText={isSaving ? SAVING_LABEL : SAVE_AND_UPLOAD_LABEL}
      onCancel={() => onSubmit(name, false)}
      onSave={() => onSubmit(name, true)}
      onClose={onClose}
      disableCancel={isSaving || !name}
      disableSave={isSaving || !name}
      disableOnCloseFunc
    >
      <div className="w-full py-4">
        <TextInput
          id="fax-letter-document-name"
          label={DOCUMENT_NAME_LABEL}
          placeholder="Enter Document Name"
          defaultValue={defaultDocumentName}
          onChange={(data) => setDocumentName(data.value)}
        />
      </div>
    </Modal>
  );
};

export default SaveReviewModal;
